import { createContext, useContext, useState, useMemo, ReactNode } from 'react';

interface BlockContextInterface {
  isHover: boolean;
  isActive: boolean;
}

export const BlockContext =
  createContext<BlockContextInterface | undefined>(undefined);

export const useBlockContext = () => useContext(BlockContext);

interface ChildrenArgs {
  onMouseEnter?: React.MouseEventHandler;
  onMouseDown?: React.MouseEventHandler;
  onMouseLeave?: React.MouseEventHandler;
}
interface Props {
  children: (props: ChildrenArgs) => ReactNode;
}

export function BlockContextProvider({ children }: Props) {
  const [isHover, setHover] = useState(false);
  const [isActive, setActive] = useState(false);

  const handleMouseEnter = () => setHover(true);
  const handleMouseDown = () => setActive(true);
  const handleMouseLeave = () => {
    setHover(false);
    setActive(false);
  };

  const context = useMemo<BlockContextInterface>(
    () => ({ isHover, isActive }),
    [isHover, isActive],
  );

  const handlers = {
    onMouseEnter: handleMouseEnter,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
  };

  return (
    <BlockContext.Provider value={context}>
      {children(handlers)}
    </BlockContext.Provider>
  );
}
